import React from 'react';
import * as _ from 'lodash';
import { NotFound } from '../pages/NotFound';

/**
 * @description role_idによって表示/非表示を切り替える。
 */
export const UserTypeSwitchForm = ({ match_id, exc_id, children }) => {
  const role_id = parseInt(localStorage.getItem('role_id'), 10);

  if (_.isArray(match_id) && match_id.indexOf(role_id) !== -1) {
    return children;
  } else if (match_id && match_id === role_id) {
    return children;
  }

  if (_.isArray(exc_id)) {
    if (exc_id.indexOf(role_id) === -1) {
      return children;
    }
  } else if (exc_id && exc_id !== role_id) {
    return children;
  }

  return null;
};

/**
 * @description 閲覧権限を Page Componentに付与する
 * @param {Page Component} Class
 */
export const readingAuth = auth_ids => {
  return Class => {
    const role_id = +window.localStorage.getItem('role_id');

    if (!_.isArray(auth_ids)) {
      auth_ids = [auth_ids];
    }

    if (auth_ids.indexOf(role_id) === -1) {
      const notFoundInside = () => (
        <div
          style={{
            background: 'white',
            zIndex: 9999999999999,
            position: 'relative',
          }}
        >
          <NotFound />
        </div>
      );
      return notFoundInside;
    }

    return Class;
  };
};



// WEBPACK FOOTER //
// ./src/components/UserTypeSwitchForm.jsx